import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getFormCate, addFormDetail, updateFormDetail, queryFormDetails, updateFormDetailsUseStatus, addFormDetailDesign, saveAll, getFormDetailDesign, queryFormButtonList } from '@/services/form';
import { getAllOrgan } from '@/services/form.js';
import { getUser } from '@/services/system.js';
import selectPerson from '@/components/select-person/genera';
var routesConfig = localStorage.getItem(process.env.VUE_APP_ROUTES_KEY);
var columns = [{
  title: '表单名称',
  dataIndex: 'formName',
  width: 400,
  key: 'formName'
}, {
  title: '表单类型',
  dataIndex: 'cateId',
  scopedSlots: {
    customRender: 'cateType'
  },
  key: 'cateId'
}, {
  title: '表单描述',
  dataIndex: 'remarks',
  key: 'remarks'
}, {
  title: '状态',
  dataIndex: 'status',
  scopedSlots: {
    customRender: 'statusType'
  },
  key: 'status'
}, {
  title: '操作',
  scopedSlots: {
    customRender: 'operation'
  },
  key: 'action'
}];
export default {
  components: {
    selectPerson: selectPerson
  },
  name: 'templateMgr',
  watch: {
    formConfig: {
      handler: function handler(newVal, oldVal) {},
      deep: true // 新增：深度监听对象内部变化
    },
    // 核心修复：监听userGroupList1变化，实时同步useScopes（删除/新增组织后立即更新）
    userGroupList1: {
      handler: function handler(newVal) {
        if (!newVal) return;
        var organData = newVal.organData,
          postData = newVal.postData,
          userData = newVal.userData;
        var useScopes = [];
        // 解析组织数据（tabType=0）
        organData.forEach(function (item) {
          useScopes.push({
            formId: item.formId,
            tabType: 0,
            organId: item.actorId,
            organName: item.actorName,
            typeId: item.typeId || 0,
            postId: 0,
            postName: '',
            userId: 0,
            userName: ''
          });
        });
        // 解析岗位数据（tabType=2/4：组织岗位/岗位）
        postData.forEach(function (item) {
          useScopes.push({
            formId: item.formId,
            tabType: item.tabType,
            organId: item.organId || 0,
            organName: item.organName || '',
            typeId: item.typeId || 0,
            postId: item.actorId,
            postName: item.actorName,
            userId: 0,
            userName: ''
          });
        });
        // 解析人员数据（tabType=1/3/5：组织成员/组织岗位成员/岗位成员）
        userData.forEach(function (item) {
          useScopes.push({
            formId: item.formId,
            tabType: item.tabType,
            organId: item.organId || 0,
            organName: item.organName || '',
            typeId: item.typeId || 0,
            postId: item.postId || 0,
            postName: '',
            userId: item.actorId,
            userName: item.actorName
          });
        });
        // 实时更新提交用的useScopes，删除后立即同步最新数据
        this.useScopes = useScopes;
      },
      deep: true // 必须：深度监听对象内部数组的增删改
    }
  },
  data: function data() {
    var userGroupTabList = [{
      title: '组织',
      value: 0
    }, {
      title: '组织成员',
      value: 1
    }, {
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }, {
      title: '岗位',
      value: 4
    }, {
      title: '岗位成员',
      value: 5
    }];
    var organInfo = [{
      title: '组织',
      value: 0
    }, {
      title: '组织成员',
      value: 1
    }, {
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }];
    return {
      btnlist: [],
      userGroupTabList: userGroupTabList,
      organInfo: organInfo,
      formName: '',
      formConfig: {},
      // 修复：初始化为空对象，避免undefined报错
      xmlStr: '',
      procDefId: '',
      jsonData: {},
      expand: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      form: {
        formName: undefined,
        cateId: undefined,
        status: '1',
        currentNo: 1,
        pageSize: 10
      },
      columns: columns,
      total: 0,
      dataSource: [],
      // 修复：移除全局变量，用组件内部数据
      selectedRows: [],
      cateList: [{
        cateId: 1,
        cateMemo: '',
        cateName: '行政',
        parentId: 0,
        sortNum: 1,
        status: 1,
        treeLevel: 0
      }],
      visible: false,
      updateVisible: false,
      confirmLoading: false,
      addForm: {
        formName: '',
        cateId: '',
        remarks: ''
      },
      updateForm: {
        formId: '',
        formName: '',
        cateId: '',
        remarks: '',
        useScopes: null
      },
      useScopes: [],
      // 提交给后端的填单范围，实时同步
      rules: {
        formName: [{
          required: true,
          message: '请输入表单名称',
          trigger: 'blur'
        }],
        cateId: [{
          required: true,
          message: '请选择表单类型',
          trigger: 'change'
        }]
      },
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        total: 0,
        pageSizeOptions: ['5', '10', '20', '30', '40', '100'],
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        onShowSizeChange: this.pageSizeChange,
        onChange: this.pageChange
      },
      userGroupList1: {
        postData: [],
        userData: [],
        organData: []
      },
      // 选人组件绑定值
      loading: false // 新增：加载状态管理
    };
  },
  methods: {
    queryButtonList: function queryButtonList() {
      var _this = this;
      queryFormButtonList().then(function (res) {
        _this.btnlist = (res === null || res === void 0 ? void 0 : res.data.data) || [];
      });
    },
    hasPermission: function hasPermission(resourceKey) {
      if (!resourceKey) {
        return false;
      }
      if (!Array.isArray(this.btnlist)) {
        this.btnlist = [];
        return false;
      }
      var matchedItems = this.btnlist.filter(function (item) {
        return item.resource === resourceKey;
      });
      var hasAuth = matchedItems.length > 0;
      return hasAuth;
    },
    initDict: function initDict() {
      var _this2 = this;
      getFormCate().then(function (res) {
        var list = res.data.data;
        _this2.cateList = list || [];
      });
    },
    queryTableList: function queryTableList() {
      this.form.currentNo = 1;
      this.pagination.current = 1;
      this.queryTemplateList();
      sessionStorage.removeItem('Pagination_templateMgr');
    },
    queryTemplateList: function queryTemplateList() {
      var _this3 = this;
      this.loading = true;
      queryFormDetails(this.form).then(function (res) {
        var _res$data = res.data,
          code = _res$data.code,
          data = _res$data.data;
        if (code == 200) {
          _this3.dataSource = (data === null || data === void 0 ? void 0 : data.rows) || [];
          _this3.total = (data === null || data === void 0 ? void 0 : data.total) || 0;
          _this3.pagination.total = _this3.total;
        } else {
          _this3.$message.error(res.data.message || '获取表单列表失败');
          _this3.dataSource = [];
          _this3.total = 0;
        }
      }).catch(function (err) {
        _this3.$message.error('网络异常，获取表单列表失败');
        _this3.dataSource = [];
        _this3.total = 0;
      }).finally(function () {
        _this3.loading = false; // 修复：重置加载状态
      });
    },
    pageSizeChange: function pageSizeChange(val, pageNum) {
      this.loading = true;
      this.pagination.pageSize = pageNum;
      this.pagination.current = 1;
      this.form.pageSize = pageNum;
      this.form.currentNo = 1;
      this.queryTemplateList();
    },
    pageChange: function pageChange(page, val) {
      this.loading = true;
      this.pagination.current = page;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = page;
      sessionStorage.setItem('Pagination_templateMgr', JSON.stringify(this.pagination));
      this.queryTemplateList();
    },
    addNew: function addNew() {
      this.visible = true;
    },
    handleOk: function handleOk() {
      var _this4 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) _this4.asyncAddFormDetail();
      });
    },
    handleUpdate: function handleUpdate() {
      var _this5 = this;
      this.$refs.updateRuleForm.validate(function (valid) {
        if (valid) _this5.asyncUpdateFormDetail();
      });
    },
    asyncAddFormDetail: function asyncAddFormDetail() {
      var _this6 = this;
      this.confirmLoading = true;
      addFormDetail(this.addForm).then(function (res) {
        var code = res.data.code;
        if (code == 200) {
          _this6.$message.success('新增表单成功');
          _this6.$refs.ruleForm.resetFields();
          _this6.addForm = {
            formName: '',
            cateId: '',
            remarks: ''
          };
          _this6.visible = false;
          _this6.queryTemplateList();
        } else {
          _this6.$message.error(res.data.message || '新增表单失败');
        }
      }).catch(function (err) {
        _this6.$message.error('网络异常，新增表单失败');
      }).finally(function () {
        _this6.confirmLoading = false;
      });
    },
    // 核心修复：提交时直接用实时同步的useScopes，无需手动赋值
    asyncUpdateFormDetail: function asyncUpdateFormDetail() {
      var _this7 = this;
      this.confirmLoading = true;
      // 提交最新的表单数据+实时同步的填单范围
      var submitData = _objectSpread(_objectSpread({}, this.updateForm), {}, {
        useScopes: this.useScopes
      });
      updateFormDetail(submitData).then(function (res) {
        var code = res.data.code;
        if (code == 200) {
          _this7.$message.success('修改表单成功');
          _this7.$refs.updateRuleForm.resetFields();
          // 彻底重置修改相关数据
          _this7.updateForm = {
            formId: '',
            formName: '',
            cateId: '',
            remarks: '',
            useScopes: null
          };
          _this7.userGroupList1 = {
            postData: [],
            userData: [],
            organData: []
          };
          _this7.useScopes = [];
          _this7.updateVisible = false;
          _this7.queryTemplateList();
        } else {
          _this7.$message.error(res.data.message || '修改表单失败');
        }
      }).catch(function (err) {
        _this7.$message.error('网络异常，修改表单失败');
      }).finally(function () {
        _this7.confirmLoading = false;
      });
    },
    handleCancel: function handleCancel() {
      var _this$$refs$ruleForm;
      (_this$$refs$ruleForm = this.$refs.ruleForm) === null || _this$$refs$ruleForm === void 0 || _this$$refs$ruleForm.resetFields();
      this.addForm = {
        formName: '',
        cateId: '',
        remarks: ''
      };
      this.visible = false;
    },
    // 修复：关闭修改弹窗时彻底重置，避免残留数据
    handleCancel1: function handleCancel1() {
      var _this$$refs$updateRul;
      (_this$$refs$updateRul = this.$refs.updateRuleForm) === null || _this$$refs$updateRul === void 0 || _this$$refs$updateRul.resetFields();
      this.updateForm = {
        formId: '',
        formName: '',
        cateId: '',
        remarks: '',
        useScopes: null
      };
      this.userGroupList1 = {
        postData: [],
        userData: [],
        organData: []
      }; // 重置选人组件
      this.useScopes = []; // 重置提交数据
      this.updateVisible = false;
    },
    onClickDesign: function onClickDesign(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/designMgr',
        query: {
          moduleId: record.formId,
          isView: true
        }
      });
    },
    onClickView: function onClickView(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/designMgr',
        query: {
          moduleId: record.formId,
          isView: false
        }
      });
    },
    // 修复：状态切换用record.status，而非筛选的form.status
    onClickChangeUseStatus: function onClickChangeUseStatus(text, record) {
      var _this8 = this;
      var param = {
        formId: record.formId,
        status: record.status == 1 ? 0 : 1
      };
      updateFormDetailsUseStatus(param).then(function (res) {
        if (res.data.code == 200) {
          _this8.$message.success('表单状态修改成功');
          _this8.queryTemplateList();
        } else {
          _this8.$message.error(res.data.message || '表单状态修改失败');
        }
      }).catch(function (err) {
        _this8.$message.error('网络异常，表单状态修改失败');
      });
    },
    // 修复：打开修改弹窗时容错+重置，避免残留和报错
    onClickUpdate: function onClickUpdate(text, record) {
      var _this$$refs$updateRul2,
        _this9 = this;
      // 先重置所有修改相关数据，防止残留上一次的内容
      (_this$$refs$updateRul2 = this.$refs.updateRuleForm) === null || _this$$refs$updateRul2 === void 0 || _this$$refs$updateRul2.resetFields();
      this.userGroupList1 = {
        postData: [],
        userData: [],
        organData: []
      };
      this.useScopes = [];
      // 赋值表单基础数据
      this.updateForm = _objectSpread({}, record);
      this.updateVisible = true;

      // 获取填单范围详情
      getFormDetailDesign({
        formId: record.formId
      }).then(function (res) {
        if (res.data.code !== 200) return _this9.$message.error('获取表单详情失败');
        var _res$data$data = res.data.data,
          formDetailVersion = _res$data$data.formDetailVersion,
          formConfig = _res$data$data.formConfig,
          flowData = _res$data$data.flowData,
          formName = _res$data$data.formName;
        _this9.xmlStr = (flowData === null || flowData === void 0 ? void 0 : flowData.xml) || '';
        _this9.procDefId = (flowData === null || flowData === void 0 ? void 0 : flowData.procDefId) || '';
        _this9.jsonData = formDetailVersion !== null && formDetailVersion !== void 0 && formDetailVersion.formData ? JSON.parse(formDetailVersion.formData) : {};
        _this9.formConfig = formConfig || {}; // 容错：空对象
        _this9.formName = formName || '';

        // 容错：formConfig可能没有useScopes，默认空数组
        var useScopes = _this9.formConfig.useScopes || [];
        _this9.useScopes = useScopes; // 初始赋值

        // 解析原始数据到选人组件，供编辑/删除
        if (useScopes.length > 0) {
          useScopes.forEach(function (item) {
            if ([0].indexOf(item.tabType) > -1) {
              // 组织
              _this9.userGroupList1.organData.push({
                formId: item.formId,
                actorId: item.organId,
                actorName: item.organName,
                typeId: item.typeId,
                tabType: item.tabType
              });
            }
            if ([2, 4].indexOf(item.tabType) > -1) {
              // 组织岗位/岗位
              _this9.userGroupList1.postData.push({
                formId: item.formId,
                actorId: item.postId,
                actorName: item.postName,
                organId: item.organId == 0 ? undefined : item.organId,
                organName: item.organName,
                typeId: item.typeId == 0 ? undefined : item.typeId,
                tabType: item.tabType
              });
            }
            if ([1, 3, 5].indexOf(item.tabType) > -1) {
              // 人员
              _this9.userGroupList1.userData.push({
                formId: item.formId,
                actorId: item.userId,
                actorName: item.userName,
                organId: item.organId == 0 ? undefined : item.organId,
                postId: item.postId == 0 ? undefined : item.postId,
                typeId: item.typeId == 0 ? undefined : item.typeId,
                tabType: item.tabType
              });
            }
          });
        }
      });
    },
    radioOnChange: function radioOnChange() {
      this.queryTemplateList();
    },
    loadUsers: function loadUsers() {
      var _this0 = this;
      getUser().then(function (res) {
        _this0.form.userData = res.data.data || [];
      });
    },
    getOrganAll: function getOrganAll() {
      var _this1 = this;
      getAllOrgan().then(function (res) {
        if (res.data.code == 200) {
          _this1.form.treeData = res.data.data || [];
        }
      });
    }
  },
  mounted: function mounted() {
    this.queryButtonList();
    this.initDict();
    // 恢复分页缓存
    var savedPagination = sessionStorage.getItem('Pagination_templateMgr');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.pagination.current = parsed.current || 1;
        this.pagination.pageSize = parsed.pageSize || 10;
        this.form.currentNo = parsed.current || 1;
        this.form.pageSize = parsed.pageSize || 10;
      } catch (e) {}
    }
    this.queryTemplateList();
  }
};